import network from "@/api/network";

export default class Usercard {
  static async getUserCard(user_id, project_id) {
    return await network.get(`user/${user_id}/project/${project_id}/profile`, null, {});
  }

  static async moveDataFromUser(data) {
    return await network.post("user/relations/change", data, {});
  }

  static async addPoints(data) {
    return await network.post("points/user/add", data, {});
  }

  static async subPoints(data) {
    return await network.post("points/user/subtract", data, {});
  }

  static async getUserInfo(user_id) {
    return await network.get(`user/cards/info/${user_id}`, null, {});
  }

  static async getUserСurators(user_id) {
      return await network.get(`user/cards/info/${user_id}/curators`, null, {});
  }

  static async updateUserInfo(data) {
    return await network.put(`user/cards/info`, data, {});
  }

  static async getUserPassport(user_id) {
    return await network.get(`user/cards/passports/${user_id}`, null, {});
  }

  static async updateUserPassport(data) {
    return await network.put(`user/cards/passports`, data, {});
  }

  static async getUserPassportScan(pass_id) {
    return await network.get(`user/cards/passports/scans/${pass_id}`, null, {});
  }

  static async updateUserPassportScanFirst(data) {
    return await network.post(`/user/cards/passports/scans/first`, data, {});
  }

  static async updateUserPassportScanSecond(data) {
    return await network.post(`/user/cards/passports/scans/second`, data, {});
  }

  static async getUserHistory(user_id) {
    return await network.get(`user/cards/${user_id}/history`, null, {});
  }

  static async getUserRelations(user_id) {
    return await network.get(`user/cards/relations/${user_id}`, null, {});
  }

  static async updateUserRelations(data) {
    return await network.put(`user/cards/relations`, data, {});
  }

  static async getUserCompanies(user_id) {
    return await network.get(`user/cards/${user_id}/companies`, null, {});
  }

  static async updateUserCompanies(data) {
    return await network.put(`user/cards/companies`, data, {});
  }

  static async updateUserCompaniesRegion(data) {
    return await network.put(`user/cards/companies/actual/region`, data, {});
  }

  static async getUserCompaniesCities(user_id) {
    return await network.get(`user/cards/${user_id}/companies/cities`, null, {});
  }

  static async getUserPrizes(user_id, project_id, page) {
    return await network.get(`user/cards/${project_id}/${user_id}/prizes?page=${page}&per_page=10`, null, {});
  }

  static async getUserBalance(user_id, project_id) {
    return await network.get(`user/cards/${project_id}/${user_id}/balance`, null, {});
  }

  static async getUserTransactions(user_id, project_id, page) {
    return await network.get(`user/cards/${project_id}/${user_id}/points?page=${page}&per_page=10`, null, {});
  }
}
